// Constants
import { TransactionMessageType } from '../../constants'

// Utilities
import Formatter from '../../utility/formatterUtil.js'
import isEmpty from '../../utility/isEmpty'

// Validators
import { phone } from '../../validators/phone'

export default {
  /**
   * If there is currently a logged in user object.
   * @returns {Boolean} True if there is a logged in user object.
   */
  userExists (state) {
    return !isEmpty(state.user)
  },

  getCognitoId (state, getters) {
    return getters.userExists && state.user.signInUserSession && state.user.signInUserSession.accessToken && state.user.signInUserSession.accessToken.payload ? state.user.signInUserSession.accessToken.payload.sub : undefined
  },

  getUsername (state, getters) {
    if (getters.userExists && !isEmpty(state.user.username) && (state.user.username.includes('@') || state.user.username.includes('+1'))) {
      return state.user.username
    }

    if (!state.username) {
      return ''
    }

    if (phone(state.username.substring(2))) {
      return state.username.substring(2)
    }

    return state.username
  },

  isServiceAvailable (state) {
    return state.serviceAvailable === true
  },

  contactMethods (state, getters, rootState) {
    if (!isEmpty(rootState.customer.communicationSettings)) {
      if (rootState.customer.communicationSettings.transMsgPreference === TransactionMessageType.Both && !isEmpty(state.email) && !isEmpty(state.phone)) {
        return {
          email: state.email,
          phone: state.phone
        }
      }

      if (rootState.customer.communicationSettings.transMsgPreference === TransactionMessageType.Email && !isEmpty(state.email)) {
        return {
          email: state.email
        }
      }

      if (rootState.customer.communicationSettings.transMsgPreference === TransactionMessageType.Text && !isEmpty(state.phone)) {
        return {
          phone: state.phone
        }
      }
    }

    if (!isEmpty(state.email) && state.emailVerified) {
      return {
        email: state.email
      }
    }

    if (!isEmpty(state.phone) && state.phoneVerified) {
      return {
        phone: state.phone
      }
    }

    if (phone(getters.getUsername)) {
      return {
        phone: getters.getUsername
      }
    } else {
      return {
        email: getters.getUsername
      }
    }
  },

  getOutForRepoPhoneNumber (state) {
    return !isEmpty(state.outForRepoConfig) && !isEmpty(state.outForRepoConfig.phoneNumber) ? state.outForRepoConfig.phoneNumber : ''
  },

  getDebtSoldPhoneNumber (state) {
    return !isEmpty(state.debtSoldConfig) && !isEmpty(state.debtSoldConfig.phoneNumber) ? state.debtSoldConfig.phoneNumber : ''
  },

  getDebtBuyerName (state) {
    return !isEmpty(state.debtSoldConfig) && !isEmpty(state.debtSoldConfig.debtBuyerName) ? state.debtSoldConfig.debtBuyerName : ''
  },

  customerIsEditing (state) {
    return state.applicationEditMode
  },

  isAwaitingSignature (state) {
    return state.awaitingSignature
  },

  usernameIsEmail (state) {
    return getUserIsEmail(state.username)
  },

  formattedUsername: (state, getters) => (username) => {
    const usernameIsEmail = getUserIsEmail(username)

    if (!isEmpty(username)) {
      username = username.toLowerCase().trim()
    }

    return usernameIsEmail ? username : `+1${Formatter.stripPhoneNumber(username)}`
  }
}

const getUserIsEmail = (username) => {
  return isEmpty(username) ? true : username.includes('@')
}
